import React, { ReactNode } from "react";
import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import { TMode } from "../../../hooks/useModeColor";
import ToggleIconLink from "../../../Components/ToggleIconLink";

interface IControlDetailsPanelProps {
  mode: TMode;
  title: string;
  children?: ReactNode;
}

const ControlDetailsPanel = (props: IControlDetailsPanelProps) => {
  const { mode, title, children } = props;

  return (
    <Box padding={{ xs: 1, sm: 1 }}>
      <Paper
        sx={{
          textAlign: "center",
          bgcolor: `${mode}.main`,
          color: `${mode}.text`,
          padding: 1,
        }}
      >
        <Stack
          direction="column"
          alignItems="stretch"
          justifyContent="flex-start"
          padding={0}
          spacing={1}
        >
          <Grid container padding={{ xs: 0, sm: 0 }} spacing={{ xs: 0, sm: 0 }}>
            <Grid size={1}></Grid>
            <Grid size={10}>
              <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                {title}
              </Typography>
            </Grid>
            <Grid size={1}>
              <ToggleIconLink to={"/"} name={"arrow-left"} />
            </Grid>
          </Grid>
          {children}
        </Stack>
      </Paper>
    </Box>
  );
};

export default ControlDetailsPanel;
